import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Lock, Eye, EyeOff } from 'lucide-react';

const APP_USERS = ['BOUVENGJ', 'BOUVENGP2', 'DONGB3', 'SOTOCRUZL', 'SOTOASTOL2'];

export default function LoginPage() {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();

  const redirectTo = searchParams.get('redirect') || '/dashboard';
  const hasError = searchParams.get('error');

  const handleSubmit = (e) => {
    if (!login) { e.preventDefault(); return; }
    setLoading(true);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--hp-black)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Background grid */}
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: 'linear-gradient(var(--hp-border) 1px, transparent 1px), linear-gradient(90deg, var(--hp-border) 1px, transparent 1px)',
        backgroundSize: '60px 60px',
        opacity: 0.3,
      }} />
      {/* Gold glow */}
      <div style={{
        position: 'absolute',
        top: '30%', left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '600px', height: '600px',
        background: 'radial-gradient(circle, rgba(201,168,76,0.06) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div style={{
        position: 'relative',
        width: '100%',
        maxWidth: '400px',
        animation: 'slideUp 400ms cubic-bezier(0.4,0,0.2,1)',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '64px', height: '64px',
            background: 'linear-gradient(135deg, rgba(201,168,76,0.2), rgba(201,168,76,0.05))',
            border: '1px solid rgba(201,168,76,0.3)',
            borderRadius: '16px',
            marginBottom: '20px',
          }}>
            <Lock size={28} color="var(--hp-gold)" />
          </div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '2.8rem', color: 'var(--hp-gold)', letterSpacing: '0.06em' }}>
            HOLLYPAUL
          </h1>
          <p style={{ fontFamily: 'var(--font-mono)', fontSize: '0.7rem', color: 'var(--hp-dim)', letterSpacing: '0.2em', textTransform: 'uppercase', marginTop: '4px' }}>
            App Engine — Secure Access
          </p>
        </div>

        {/* Card */}
        <div style={{
          background: 'var(--hp-card)',
          border: '1px solid var(--hp-border)',
          borderRadius: 'var(--radius-lg)',
          padding: '32px',
          boxShadow: '0 24px 80px rgba(0,0,0,0.5)',
        }}>
          <h4 style={{ marginBottom: '4px' }}>Site Access</h4>
          <p style={{ color: 'var(--hp-dim)', fontSize: '0.875rem', marginBottom: '24px' }}>
            Enter your password to continue
          </p>

          {hasError && (
            <div style={{
              background: 'rgba(239,68,68,0.1)',
              border: '1px solid rgba(239,68,68,0.3)',
              borderRadius: 'var(--radius)',
              padding: '10px 14px',
              color: 'var(--hp-red)',
              fontSize: '0.875rem',
              marginBottom: '16px',
            }}>
              Incorrect login ID or password. Please try again.
            </div>
          )}

          {/* In production, this form posts to /auth edge function */}
          <form onSubmit={handleSubmit} action="/auth" method="POST">
            <input type="hidden" name="redirect" value={redirectTo} />
            <div className="form-group" style={{ marginBottom: '16px' }}>
              <label className="form-label">Login ID</label>
              <select
                name="login"
                className="form-input"
                value={login}
                onChange={e => setLogin(e.target.value)}
                required
              >
                <option value="">Select your login…</option>
                {APP_USERS.map(u => (
                  <option key={u} value={u}>{u}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={show ? 'text' : 'password'}
                  name="password"
                  className="form-input"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Enter site password"
                  autoFocus
                  style={{ paddingRight: '44px' }}
                />
                <button
                  type="button"
                  onClick={() => setShow(!show)}
                  style={{
                    position: 'absolute', right: '12px', top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none', border: 'none',
                    color: 'var(--hp-dim)', cursor: 'pointer',
                    display: 'flex', alignItems: 'center',
                  }}
                >
                  {show ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary w-full"
              disabled={loading || !password || !login}
              style={{ justifyContent: 'center', marginTop: '8px', opacity: loading ? 0.7 : 1 }}
            >
              {loading ? 'Verifying...' : 'Access App Engine'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', color: 'var(--hp-muted)', fontSize: '0.72rem', marginTop: '20px', fontFamily: 'var(--font-mono)' }}>
          HOLLYPAUL — CONFIDENTIAL
        </p>
      </div>
    </div>
  );
}
